import type { DesignProductPresenter } from '../../../../products/';
import type { Category, CategoryPageConfig } from './categories';

export const createCategory = (
    id: string,
    name: string,
    products: DesignProductPresenter[],
    pageConfig?: CategoryPageConfig
): Category => ({
    id,
    name,
    products,
    pageConfig,
});
